export default __webpack_public_path__ + "static/media/Group9202.9d0f19bb.svg";